import script from "./AgentActionCategories.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentActionCategories.vue?vue&type=script&lang=ts&setup=true"

import "./AgentActionCategories.vue?vue&type=style&index=0&id=41347f36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41347f36"]])

export default __exports__